import React from 'react';
import styles from '@features/voucher-new/styles/voucher-new.module.css';
import cn from 'classnames';
import { useAtomValue } from 'jotai';

import { isRTL } from '@shared/utils/general';
import { languageAtom } from '@shared/store/slice-atoms';
export const VoucherInputField = ({ title, value, handleChange, placeholder, error = '' }) => {
  const { direction } = useAtomValue(languageAtom);
  const isRTLDirection = isRTL(direction);

  return (
    <div className={styles.voucherInputFieldWrapper}>
      <p className={cn(styles.inputFieldTitle, isRTLDirection ? styles.inputFieldTitleRTL : '')}>
        {title}
      </p>

      <input
        className={styles.voucherInput}
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
      />

      {!!error && <p className={styles.inputFieldError}>{error}</p>}
    </div>
  );
};
